export const Identities = [
    // {
    //     value: '技术经理人',
    //     key: '01',
    //     order: 1,
    //     role: 'technicalManager',
    //     icon: 'icon-jingjiren'
    // },
    // {
    //     value: '事务所',
    //     key: '02',
    //     order: 1,
    //     role: 'agency',
    //     icon: 'icon-agency'
    // },
    // {
    //     value: '法务服务机构',
    //     key: '03',
    //     order: 5,
    //     alias: '法务服务机构',
    //     role: 'service',
    //     icon: 'icon-message'
    // },
    // {
    //     value: '知识产权服务机构',
    //     key: '04',
    //     order: 6,
    //     alias: '知识产权服务机构',
    //     role: 'service',
    //     icon: 'icon-message'
    // },
    // {
    //     value: '金融服务机构',
    //     key: '05',
    //     order: 7,
    //     alias: '金融服务机构',
    //     role: 'service',
    //     icon: 'icon-message'
    // },
    // // {
    // //     value: '代理商',
    // //     key: '06',
    // //     desc: '代',
    // //     color: '#FB9109'
    // // },
    // {
    //     value: '高校',
    //     key: '07',
    //     order: 3,
    //     role: 'college',
    //     icon: 'icon-gaoxiao'
    // },
    // {
    //     value: '专家',
    //     key: '08',
    //     order: 2,
    //     role: 'expert',
    //     icon: 'icon-ziyuan'
    // },
    // {
    //     value: '技术转移中心',
    //     key: '09',
    //     order: 2,
    //     role: 'economic',
    //     icon: 'icon-jingjiren'
    // },
    // {
    //     value: '科研院所',
    //     key: '10',
    //     order: 4,
    //     role: 'science',
    //     icon: 'icon-science'
    // },
    // {
    //     value: '技术经纪服务机构',
    //     key: '11',
    //     order: 8,
    //     role: 'service',
    //     alias: '技术经纪服务机构',
    //     icon: 'icon-message'
    // },
    // {
    //     value: '创业孵化服务机构',
    //     key: '12',
    //     order: 9,
    //     alias: '创业孵化服务机构',
    //     role: 'service',
    //     icon: 'icon-message'
    // },
    // {
    //     value: '企业',
    //     key: '15',
    //     order: 10,
    //     alias: '企业',
    //     role: 'seller',
    //     icon: 'icon-message'
    // },
    // {
    //     value: '大院大所',
    //     key: '16',
    //     order: 11,
    //     alias: '大院大所',
    //     role: 'seller',
    //     icon: 'icon-message'
    // }

    {
        value: '技术经理人',
        key: '01',
        desc: '纳入江苏省技术产权交易市场备案管理，利用省技术市场平台及所挂靠事务所业务资源，以实现科技成果转化和技术转移服务为目的，通过咨询分析、对接撮合及资源引荐等居间服务方式，促成技术持有方与技术需求方达成交易或合作，并取得合理佣金的，具有完全民事行为能力的自然人。',
        order: 1,
        role: 'technicalManager'
    },
    {
        value: '事务所',
        key: '02',
        order: 1,
        role: 'agency',
        icon: 'icon-agency'
    },
    {
        value: '高校',
        key: '07',
        desc: '高校是是大学、学院、独立学院、高等职业技术大学、高等职业技术学院、高等专科学校的统称。高校设立的具有独立法人资格的技术转移公司不可申请高校身份。',
        order: 3,
        role: 'college'
    },
    {
        value: '专家',
        key: '08',
        desc: '从事技术研发、技术转移、科技成果转化以及产学研合作项目实施工程，具备丰富专业知识和实践经验的专家教授。',
        order: 2,
        role: 'expert'
    },
    {
        value: '企业',
        key: '15',
        desc: '企业是技术需求方，也是技术供应方',
        order: 2,
        role: 'company'
    },
    {
        value: '科研院所',
        key: '10',
        desc: '科研院所是指对实施科研、科学研究的研究院和研究所的统称。',
        order: 4,
        role: 'science'
    },
    {
        value: '新型研发机构',
        key: '19',
        desc: '',
        order: 8,
        alias: '新型研发机构',
        role: 'service'
    },
    {
        value: '技术转移服务机构',
        key: '17',
        desc: '',
        order: 9,
        alias: '技术转移服务机构',
        role: 'technicalTransfer'
    }
]
